import { Box, Button, Dialog, Slide, Typography } from "@mui/material";
import React, { forwardRef } from "react";
import dayjs from "dayjs";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MultipleOrderSelectModal({ open, orders, handleClose, handleSelect }) {

  const renderNotesAndSubItems = (item) => {
    const rows = [];
    if (item?.allergyNote) {
      rows.push(
        <Typography key={`${item.id}-allergy`} variant="body2" fontStyle="italic" sx={{ marginLeft: "1rem" }}>
          {item.allergyNote}
        </Typography>
      );
    }
    if (item?.removedItems) {
      rows.push(
        <Typography key={`${item.id}-removed`} variant="body2" fontStyle="italic" sx={{ marginLeft: "1rem" }}>
          Remove: {item.removedItems} (ALLERGY)
        </Typography>
      );
    }
    if (item?.specialNote) {
      rows.push(
        <Typography key={`${item.id}-special`} variant="body2" sx={{ marginLeft: "1rem" }}>
          Special Note: {item.specialNote}
        </Typography>
      );
    }
    item?.subItems?.forEach((sub) => {
      rows.push(
        <Typography key={`${item.id}-sub-${sub.id}`} variant="body2" sx={{ marginLeft: "1rem" }}>
          Add - {sub.recipeName} ({sub.quantity})
        </Typography>
      );
    });
    return rows;
  }

  const renderOrders = () => {
    return orders?.map((order) => (
      <Box
        key={order.orderId}
        onClick={() => handleSelect(order)}
        sx={{
          border: "1px solid rgba(0, 0, 0, .2)",
          borderRadius: ".5rem",
          padding: "1rem",
          marginBottom: "1rem",
          cursor: "pointer",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, .04)" }
        }}
      >
        <Box display="flex" justifyContent="space-between" flexWrap="wrap" sx={{ marginBottom: ".5rem" }}>
          <Box sx={{ borderLeft: "3px solid var(--tealColor)", paddingLeft: ".5rem" }}>
            <Typography fontWeight="bold">{order.firstName} {order.lastName}</Typography>
            <Typography variant="body2">{order.diningAreaName}</Typography>
          </Box>
          <Box textAlign="right">
            <Typography>{order.mealName}</Typography>
            <Typography variant="body2">{dayjs(order.mealDate).format("dddd,[ ]M/D/YY")}</Typography>
          </Box>
        </Box>
        {order.orderItems?.map((item) => (
          <Box key={item.id} sx={{ borderTop: "1px solid rgba(0, 0, 0, .1)", padding: ".35rem 0" }}>
            <Box display="flex" justifyContent="space-between">
              <Typography>{item.recipeName}</Typography>
              <Typography>{item.quantity}</Typography>
            </Box>
            {renderNotesAndSubItems(item)}
          </Box>
        ))}
      </Box>
    ));
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { maxHeight: "75vh", display: "flex", flexDirection: "column" } }}
    >
      <Box sx={{ backgroundColor: "#01617e", padding: ".75rem 1rem", flexShrink: 0 }}>
        <Typography variant="h6" fontWeight="bold" textAlign="center" color="#FFF">
          REVIEW / EDIT ORDER
        </Typography>
      </Box>
      <Box sx={{ padding: "1rem", overflowY: "auto", flex: "1 1 auto" }}>
        <Typography fontStyle="italic" textAlign="center" sx={{ marginBottom: "1rem", whiteSpace: "pre-wrap" }}>
          Multiple orders have been submitted for this resident for this meal. {'\n'} <b>Select which meal to edit:</b>
        </Typography>
        {renderOrders()}
      </Box>
      <Box sx={{ borderTop: "1px solid lightgray", padding: "1rem", display: "flex", justifyContent: "center", flexShrink: 0 }}>
        <Button
          variant="contained"
          sx={{ fontWeight: "bold", backgroundColor: "var(--yellowColor)", color: "#000" }}
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
}